<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <v-row>
    <slot name="before" />
    <app-text-input
      v-model="form.name_ar"
      :disabled="profile"
      :readonly="profile"
      cols="12"
      sm="6"
      name="name_ar"
      required
    />
    <app-text-input
      v-model="form.name_en"
      :disabled="profile"
      :readonly="profile"
      cols="12"
      sm="6"
      name="name_en"
      required
    />
    <app-text-input
      v-model="form.username"
      :disabled="profile"
      :hint="$t('hints.username')"
      :readonly="profile"
      cols="12"
      sm="6"
      name="username"
      clearable
      persistent-hint
    />
    <app-countries
      v-model="form.country_id"
      cols="12"
      sm="6"
      name="country_id"
      clearable
      :disabled="profile"
      :readonly="profile"
    />
    <app-number-input
      v-model="form.mobile"
      :disabled="profile"
      :hint="$t('hints.mobile')"
      persistent-hint
      :readonly="profile"
      clearable
      cols="12"
      sm="6"
      name="mobile"
    />
    <app-text-input
      v-model="form.email"
      :disabled="profile"
      :readonly="profile"
      clearable
      cols="12"
      sm="6"
      name="email"
      rules="email"
    />
    <app-auto-select
      v-model="form.locale"
      :items="AppLocales"
      cols="12"
      name="locale"
      clearable
      sm="6"
      item-text="title"
      item-value="code"
      :disabled="profile"
      :readonly="profile"
    />
    <slot />
    <slot name="after" />
  </v-row>
</template>
<script>

export default {
  name: 'AccountForm',
  props: {
    value: {
      type: Object,
      default: () => undefined
    },
    profile: {
      type: Boolean,
      default: () => !1
    }
  },
  data () {
    return {}
  },
  computed: {
    form: {
      set (v) {
        this.$emit('input', v)
      },
      get () {
        return this.value
      }
    }
  }
}
</script>
